module.exports = __webpack_public_path__ + "static/womply-3ff3132a2d67305107d042077c9455e5.png";